<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="col">
          <h3 style="margin: 0;">{{ name_company }}</h3>
          <p style="margin: 0;">{{ name_user }}</p>
      </div>
      <div v-if="counter!=null && counter!=''" class="centerx">
        <vs-alert color="primary" icon="new_releases" >
          <span>Tu fecha límite de <b>Pago</b> ha caducado, no te preocupes tienes <b>{{counter}}</b> día(s) para realizar el pago.</span>
        </vs-alert>
      </div>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
              <i class="nc-icon nc-grid-45"></i>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" style="display: flex;">
            <a href="#" class="nav-link" @click="logout">
              <i style="padding-right: 2px;" class="nc-icon nc-button-power"></i>
              Cerrar Sesión</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import Vue from 'vue'
  import vuesax from 'vuesax'
  import 'vuesax/dist/vuesax.css'
  import 'material-icons/iconfont/material-icons.css'
  Vue.use(vuesax)
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false,
        name_company:JSON.parse(localStorage.getItem('jwt_licencia')).name,
        payment_date:JSON.parse(localStorage.getItem('jwt_licencia')).payment_date,
        counter:JSON.parse(localStorage.getItem('jwt_licencia')).counter,
        name_user:JSON.parse(localStorage.getItem('jwt_user')).name,
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      logout(){
        window.localStorage.removeItem('jwt_user');
        window.localStorage.removeItem('jwt_licencia');
        window.localStorage.removeItem('jwt_token');
        location.href = location.origin+'/#/login';
      },
    },
    mounted () {
    }
  }

</script>
<style>

</style>
